import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { useTrackView } from '#src/app/shared/hooks/tracking';

export function useTrackPageView(): void {
	const {
		data: {
			petition: { geoReach, relevantLocationLocalizedName, categoryTags },
		},
	} = usePsfPromoteOrSharePageData();

	useTrackView('combo_psf_view', {
		geo_reach: geoReach ?? undefined,
		category_tags: categoryTags,
		relevant_location_localized_name: relevantLocationLocalizedName ?? undefined,
	});
}
